export interface Game {
  id: string;
  name: string;
  category: string;
  icon: string;
  rating: number;
  downloads: string;
  size: string;
  version: string;
  description: string;
  features: string[];
  platforms: string[];
}

export const games: Game[] = [
  {
    id: 'ng-lucky-wheel',
    name: '南宫幸运转盘',
    category: 'casual',
    icon: 'ri-vip-crown-line',
    rating: 4.8,
    downloads: '1280万+',
    size: '86MB',
    version: 'v3.2.1',
    description: '经典转盘玩法全新升级，多种模式任你选择，超高中奖率，每日登录领取丰厚奖励，是南宫平台最受欢迎的休闲游戏之一。',
    features: ['每日免费转盘次数', '多人实时对战', '丰富奖品池', '社交分享功能'],
    platforms: ['iOS', 'Android'],
  },
  {
    id: 'ng-legend-sword',
    name: '南宫传说之剑',
    category: 'rpg',
    icon: 'ri-sword-line',
    rating: 4.9,
    downloads: '960万+',
    size: '1.2GB',
    version: 'v5.1.0',
    description: '史诗级角色扮演巨制，庞大的开放世界等你探索，精致的画面表现，深度剧情体验，打造属于你的传奇故事。',
    features: ['开放世界探索', '百种技能组合', '实时战斗系统', '公会团队副本'],
    platforms: ['iOS', 'Android', 'PC'],
  },
  {
    id: 'ng-chess-empire',
    name: '南宫棋牌帝国',
    category: 'board',
    icon: 'ri-stack-line',
    rating: 4.7,
    downloads: '1560万+',
    size: '120MB',
    version: 'v4.5.2',
    description: '集合斗地主、麻将、德州扑克等多种经典棋牌玩法，真人实时匹配，公平竞技环境，智能防作弊系统保障游戏公正。',
    features: ['多款棋牌合集', '真人实时匹配', '语音聊天', '亲友房模式'],
    platforms: ['iOS', 'Android'],
  },
  {
    id: 'ng-strategy-kingdom',
    name: '南宫策略王国',
    category: 'strategy',
    icon: 'ri-brain-line',
    rating: 4.6,
    downloads: '720万+',
    size: '450MB',
    version: 'v2.8.0',
    description: '深度策略战争游戏，建设你的王国，指挥千军万马，与其他玩家斗智斗勇，体验真正的策略博弈快感。',
    features: ['城建经营系统', '联盟战争', '科技树研究', '实时策略对战'],
    platforms: ['iOS', 'Android'],
  },
  {
    id: 'ng-speed-racer',
    name: '南宫极速狂奔',
    category: 'sports',
    icon: 'ri-speed-up-line',
    rating: 4.5,
    downloads: '580万+',
    size: '680MB',
    version: 'v3.0.1',
    description: '顶级竞速游戏体验，真实物理引擎打造极致驾驶感受，多款名车任你驾驭，全球玩家实时竞速对决。',
    features: ['真实物理引擎', '百款名车', '全球赛道', '车队系统'],
    platforms: ['iOS', 'Android', 'PC'],
  },
  {
    id: 'ng-fish-joy',
    name: '南宫欢乐捕鱼',
    category: 'casual',
    icon: 'ri-anchor-line',
    rating: 4.7,
    downloads: '2100万+',
    size: '95MB',
    version: 'v6.2.0',
    description: '全民捕鱼休闲游戏，精美的海底世界画面，多种炫酷炮台，丰富的鱼类品种，轻松上手，快乐无限。',
    features: ['3D海底场景', '多人同屏捕鱼', '丰富炮台系统', '每日BOSS挑战'],
    platforms: ['iOS', 'Android'],
  },
  {
    id: 'ng-dark-dungeon',
    name: '南宫暗黑地牢',
    category: 'rpg',
    icon: 'ri-ghost-line',
    rating: 4.8,
    downloads: '650万+',
    size: '980MB',
    version: 'v2.5.3',
    description: '暗黑风格动作RPG，随机生成的地牢探险，海量装备收集系统，挑战强大的BOSS，体验刷宝的无尽快感。',
    features: ['随机地牢生成', '海量装备系统', '技能树自定义', '多人组队探险'],
    platforms: ['iOS', 'Android', 'PC'],
  },
  {
    id: 'ng-poker-tournament',
    name: '南宫德州大赛',
    category: 'board',
    icon: 'ri-sparkling-line',
    rating: 4.6,
    downloads: '890万+',
    size: '78MB',
    version: 'v3.9.1',
    description: '专业德州扑克竞技平台，全球牌友同台竞技，多级别赛事体系，智能牌局分析，让你体验职业牌手的快感。',
    features: ['多级别赛事', '智能牌局回顾', '牌手排名系统', '锦标赛模式'],
    platforms: ['iOS', 'Android'],
  },
  {
    id: 'ng-tower-defense',
    name: '南宫塔防前线',
    category: 'strategy',
    icon: 'ri-shield-check-line',
    rating: 4.5,
    downloads: '490万+',
    size: '210MB',
    version: 'v1.8.0',
    description: '创新塔防策略游戏，融合卡牌收集元素，百种防御塔自由搭配，策略布阵抵御怪物入侵，考验你的排兵布阵能力。',
    features: ['卡牌收集系统', '百种防御塔', 'PVP对战', '无尽挑战模式'],
    platforms: ['iOS', 'Android'],
  },
  {
    id: 'ng-bubble-shooter',
    name: '南宫泡泡龙',
    category: 'casual',
    icon: 'ri-bubble-chart-line',
    rating: 4.4,
    downloads: '3400万+',
    size: '55MB',
    version: 'v7.1.0',
    description: '经典泡泡龙消除游戏，清新可爱的画风，上千个精心设计的关卡，轻松愉悦的游戏体验，老少皆宜的休闲佳作。',
    features: ['千关挑战', '可爱画风', '离线畅玩', '排行榜竞争'],
    platforms: ['iOS', 'Android'],
  },
  {
    id: 'ng-basketball-star',
    name: '南宫篮球巨星',
    category: 'sports',
    icon: 'ri-basketball-line',
    rating: 4.6,
    downloads: '420万+',
    size: '520MB',
    version: 'v2.3.2',
    description: '真实篮球竞技手游，街头篮球风格，炫酷的扣篮动作，组建你的梦之队，挑战全球篮球高手。',
    features: ['真实投篮手感', '球员养成系统', '街头赛场', '3V3对战'],
    platforms: ['iOS', 'Android'],
  },
  {
    id: 'ng-mahjong-master',
    name: '南宫麻将大师',
    category: 'board',
    icon: 'ri-layout-grid-line',
    rating: 4.8,
    downloads: '1850万+',
    size: '105MB',
    version: 'v5.0.0',
    description: '专业国粹麻将游戏，多种地方玩法，智能AI陪练，真人实时对战，语音互动让麻将更有趣。',
    features: ['多种地方玩法', '智能AI陪练', '语音聊天', '赛事竞技场'],
    platforms: ['iOS', 'Android'],
  },
];